import { motion } from "framer-motion";
import { TESTIMONIALS } from "@/data/content";
import { Quote } from "lucide-react";

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.08 } },
};
const item = {
  hidden: { opacity: 0, y: 12 },
  show: { opacity: 1, y: 0, transition: { duration: 0.45, ease: [0.21, 0.61, 0.35, 1] } },
};

export const Testimonials = () => {
  return (
    <section id="testimonials" className="py-[var(--section-py)]" data-testid="testimonials-section">
      <div className="mx-auto max-w-[var(--container-max)] px-4 sm:px-6">
        <div className="mb-12 text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[color:var(--gs-gold-400)]">
            Client Stories
          </p>
          <h2 className="font-display mt-3 text-3xl font-bold text-white sm:text-4xl" data-testid="testimonials-heading">
            Trusted by teams worldwide
          </h2>
        </div>

        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          className="grid grid-cols-1 gap-5 lg:grid-cols-2"
          data-testid="testimonials-grid"
        >
          {TESTIMONIALS.map((t) => (
            <motion.figure
              key={t.name}
              variants={item}
              data-testid="testimonial-card"
              className="rounded-[var(--radius)] border border-white/10 bg-[color:var(--gs-glass)] p-7 backdrop-blur hover:border-[color:var(--gs-line)]"
            >
              <Quote className="h-7 w-7 text-[color:var(--gs-gold-400)] opacity-70" />
              <blockquote className="mt-4 leading-relaxed text-white/80">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-full border border-[color:var(--gs-line)] bg-[rgba(240,180,41,0.12)] font-display text-sm font-bold text-[color:var(--gs-gold-400)]">
                  {t.name
                    .split(" ")
                    .map((w) => w[0])
                    .slice(0, 2)
                    .join("")}
                </div>
                <div>
                  <p className="text-sm font-semibold text-white">{t.name}</p>
                  <p className="text-xs text-white/50">
                    {t.role} — {t.location}
                  </p>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
